var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"monitoringLog"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),(_vm.data.error > 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.data.error))]):_vm._e(),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.data.message))]),_c('span',{staticClass:"detail"},[_vm._v(_vm._s(_vm.data.detail))])])
}
var staticRenderFns = []

export { render, staticRenderFns }